// Areas we serve js
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.ib-loc-namearrow').forEach(function(element) {
    element.addEventListener('click', function() {
      document.querySelectorAll('.ib-dropdown-menu').forEach(function(menu) {
        if (menu !== element.nextElementSibling) {
          menu.style.display = 'none'; 
        }
      });

      document.querySelectorAll('.ib-loc-namearrow').forEach(function(arrow) {
        if (arrow !== element) {
          arrow.classList.remove('ib-color-locname');
        }
      });

      const dropdownMenu = element.nextElementSibling;
      if (dropdownMenu) {
        const isVisible = dropdownMenu.style.display === 'block';
        dropdownMenu.style.display = isVisible ? 'none': 'block'; // Toggle visibility
      }

      element.classList.toggle('ib-color-locname');
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
    const locations = document.querySelectorAll('.ib-location-container');

    locations.forEach((location, index) => {
        if (index >= 18) {
            location.style.display = 'none';
        }
    });

    const viewAllButton = document.createElement('div');
    viewAllButton.className = 'ib-viewall-cont ib-view-all';
    viewAllButton.textContent = 'View All Locations';

    const viewLessButton = document.createElement('div');
    viewLessButton.className = 'ib-viewless-cont ib-view-all';
    viewLessButton.textContent = 'View Less';
    viewLessButton.style.display = 'none';

    const areasFlexElements = document.querySelectorAll('.ib-areas-flex');
    const lastAreasFlexElement = areasFlexElements[areasFlexElements.length - 1];

    if (lastAreasFlexElement) {
        lastAreasFlexElement.insertAdjacentElement('afterend', viewAllButton);
        lastAreasFlexElement.insertAdjacentElement('afterend', viewLessButton);
    }

    viewAllButton.addEventListener('click', function() {
        locations.forEach(location => {
            location.style.display = '';
            location.style.transition = 'all 0.2s';
        });
        viewAllButton.style.display = 'none';
        viewLessButton.style.display = 'block';
    });

    viewLessButton.addEventListener('click', function() {
        locations.forEach((location, index) => {
            if (index >= 18) {
                location.style.display = 'none';
            }
        });
        viewLessButton.style.display = 'none';
        viewAllButton.style.display = 'block';
    });
});
